import { c as _c } from "react/compiler-runtime";
import { TableCell, TableRow, TextBodySkeleton } from "@opensea/ui-kit";
import { TABLE_ROW_CLASS_NAMES } from "./utils";
export function ItemPreviewTooltipTraitTableRowSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TableCell><TextBodySkeleton /></TableCell>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TableCell><TextBodySkeleton /></TableCell>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TableRow className={TABLE_ROW_CLASS_NAMES}>{t0}{t1}<TableCell><TextBodySkeleton /></TableCell></TableRow>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}